var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAndnot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.37158 13.125C11.4782 13.125 13.9966 10.6066 13.9966 7.5C13.9966 4.3934 11.4782 1.875 8.37158 1.875C5.26498 1.875 2.74658 4.3934 2.74658 7.5C2.74658 10.6066 5.26498 13.125 8.37158 13.125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39404 3.52344L12.349 11.4784",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndnot);
export default __webpack_public_path__ + "static/media/andnot.1b4479e5fb0d5ab6daea47c94ee7f418.svg";
export { ForwardRef as ReactComponent };